import { render, staticRenderFns } from "./OurValuesImage.vue?vue&type=template&id=0ffac4ba&"
import script from "./OurValuesImage.vue?vue&type=script&lang=js&"
export * from "./OurValuesImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports